import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BASE_URL } from "../../app/helper/axiosInstance";
import { apiClient } from "../../app/helper/axiosHelper";

// Define types for your state and API responses
interface StockState {
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    error: string | null;
    data: any;
}

// Define the initial state
const initialState: StockState = {
    status: 'idle',
    error: null,
    data: null,
};


// getProfile 
export const getPortfolio = createAsyncThunk('portfolio/getPortfolio', async (gameId: number, { rejectWithValue }) => {
    try {
        const response = await apiClient.get(`${BASE_URL}/api/game/${gameId}/user/portfolio`);
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});


// Create the profile slice
const portfolioSlices = createSlice({
    name: 'portfolio',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPortfolio.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(getPortfolio.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload.data;
                state.error = null;
            })
            .addCase(getPortfolio.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
});

// Selectors for accessing state
export const selectAllPortfolio = (state: any) => state.portfolio.data;
export const selectPortfolioStatus = (state: any) => state.portfolio?.status;
export const selectPortfolioError = (state: any) => state.portfolio?.error;

export default portfolioSlices.reducer;